/** Round version carried by a live round event; null for anything else. */
export function liveRoundVersion(data: string): number | null {
  try {
    const payload = JSON.parse(data) as { roundVersion?: unknown };
    return typeof payload.roundVersion === "number"
      ? payload.roundVersion
      : null;
  } catch {
    return null;
  }
}
